export default {
  gasolineList: {
    method: 'post',
    url: '/client/costing/gasoline/list?archive=ARCHIVE'
  },
  getGasolineDetail: {
    method: 'get',
    url: '/client/costing/gasoline/detail/ID'
  },
  getGasolineLast: {
    method: 'get',
    url: '/client/costing/gasoline/get-last'
  },
  updateGasoline: {
    method: 'put',
    url: '/client/costing/gasoline/update/ID'
  },
  createGasoline: {
    method: 'post',
    url: '/client/costing/gasoline/create'
  },
  deleteGasoline: {
    method: 'DELETE',
    url: '/client/costing/gasoline/delete/ID'
  },
  archiveGasoline: {
    method: 'DELETE',
    url: '/client/costing/gasoline/archive'
  },
  restoreGasoline: {
    method: 'PUT',
    url: '/client/costing/gasoline/restore'
  }
}
